<script>
  import { location, querystring, link as linkUse } from "svelte-spa-router";
  import { _, setupI18n } from "../services/i18n";

  import { onMount } from "svelte";

  import Composition from "../components/tutorial/Composition.svelte";
  import Orders from "../components/tutorial/Orders.svelte";
  import TutoBudgets from "../components/tutorial/TutoBudgets.svelte";
  import Config from "../components/tutorial/Config.svelte";
  import Celement from "../components/tutorial/Celements.svelte";
  import Cmaterials from "../components/tutorial/Cmaterials.svelte";
  import Csummary from "../components/tutorial/Csummary.svelte";
  import Confvendors from "../components/tutorial/Confvendors.svelte";
  import Odetails from "../components/tutorial/Odetails.svelte";
  import Bdetails from "../components/tutorial/Bdetails.svelte";
  import Preset from "../components/tutorial/Preset.svelte";
  import View from "../components/tutorial/View.svelte";
  import Search from "../components/tutorial/Search.svelte";
  import Info from "../components/tutorial/Info.svelte";
  import Tools from "../components/tutorial/Tools.svelte";
  import Cart from "../components/tutorial/Cart.svelte";
  import Materialtools from "../components/tutorial/Materialtools.svelte";
  import Accessoriespage from "../components/tutorial/Accessoriespage.svelte";
  import Priceerror from "../components/tutorial/Priceerror.svelte";
  import Scenedelete from "../components/tutorial/Scenedelete.svelte";
  import Savefavourite from "../components/tutorial/Savefavourite.svelte";
  import Scene from "../components/tutorial/Scene.svelte";
  import Addcart from "../components/tutorial/Addcart.svelte";
  import Orderid from "../components/tutorial/Orderid.svelte";
  import Orderfilter from "../components/tutorial/Orderfilter.svelte";
  import Ordersettings from "../components/tutorial/Ordersettings.svelte";
  import Status from "../components/tutorial/Status.svelte";
  import Download from "../components/tutorial/Download.svelte";
  import Orderreport from "../components/tutorial/Orderreport.svelte";
  import Budgetid from "../components/tutorial/Budgetid.svelte";
  import Budgetsettings from "../components/tutorial/Budgetsettings.svelte";
  import Budgetfilter from "../components/tutorial/Budgetfilter.svelte";
  // import Budgetmodify from "../components/tutorial/Budgetmodify.svelte";
  import Budgetvisor from "../components/tutorial/Budgetvisor.svelte";
  import Budgetorder from "../components/tutorial/Budgetorder.svelte";
  import Budgetdelete from "../components/tutorial/Budgetdelete.svelte";
  import Budgetreport from "../components/tutorial/Budgetreport.svelte";
  import Clientchange from "../components/tutorial/Clientchange.svelte";
  import Vendornew from "../components/tutorial/Vendornew.svelte";
  import Vendoredit from "../components/tutorial/Vendoredit.svelte";
  import Vendordelete from "../components/tutorial/Vendordelete.svelte";
  import Conftarifs from "../components/tutorial/Conftarifs.svelte";
  
  


  export let tutoPath = undefined;

  const paths = [
    {
      url: "/compositor",
      navText: $_("tutorial_nav_composition"),
      component: Composition,
      childrens: [
        {
          url: "/compositor/composition",
          navText: $_("tutorial_nav_elements"),
          component: Celement,
          childrens: [
            {
              url: "/compositor/composition/view",
              navText: $_("tutorial_composition_view"),
              component: View,
            },
            {
              url: "/compositor/composition/search",
              navText: $_("tutorial_composition_search"),
              component: Search,
            },
            {
              url: "/compositor/composition/info",
              navText: $_("tutorial_composition_info"),
              component: Info,
            },
            {
              url: "/compositor/composition/presets",
              navText: $_("tutorial_composition_presets"),
              component: Preset,
            },
            {
              url: "/compositor/composition/tools",
              navText: $_("tutorial_composition_tools"),
              component: Tools,
            },
          ],
        },
        {
          url: "/compositor/materials",
          navText: $_("tutorial_nav_materials"),
          component: Cmaterials,
          childrens: [
            {
              url: "/compositor/materials/cart",
              navText: $_("tutorial_materials_cart"),
              component: Cart,
            },
            {
              url: "/compositor/materials/mattools",
              navText: $_("tutorial_materials_mattools"),
              component: Materialtools,
            },
          ],
        },
        {
          url: "/compositor/accessories",
          navText: $_("tutorial_nav_accessories"),
          component: Accessoriespage,
        },
        {
          url: "/compositor/summary",
          navText: $_("tutorial_nav_summary"),
          component: Csummary,
          childrens: [
            {
              url: "/compositor/summary/price",
              navText: $_("tutorial_summary_price"),
              component: Priceerror,
            },
            {
              url: "/compositor/summary/delete",
              navText: $_("tutorial_summary_delete"),
              component: Scenedelete,
            },
            {
              url: "/compositor/summary/save-fav",
              navText: $_("tutorial_summary_save"),
              component: Savefavourite,
            },
            {
              url: "/compositor/summary/scene",
              navText: $_("tutorial_summary_scene"),
              component: Scene,
            },
            {
              url: "/compositor/summary/cart",
              navText: $_("tutorial_summary_cart"),
              component: Addcart,
            },
          ],
        },
      ],
    },
    {
      url: "/orders",
      navText: $_("tutorial_nav_order"),
      component: Orders,
      childrens: [
        {
          url: "/orders/reference",
          navText: $_("tutorial_orders_reference"),
          component: Orderid,
        },
        {
          url: "/orders/filter",
          navText: $_("tutorial_orders_filter"),
          component: Orderfilter,
        },
        {
          url: "/orders/settings",
          navText: $_("tutorial_orders_settings"),
          component: Ordersettings,
        },
        {
          url: "/orders/details",
          navText: $_("tutorial_orders_details"),
          component: Odetails,
          childrens: [
            {
              url: "/orders/details/status",
              navText: $_("tutorial_orders_detail_status"),
              component:Status,
            },
            // {
            //   url: "/orders/details/ticket",
            //   navText: $_("tutorial_orders_detail_ticket"),
            //   component: Download,
            // },
            {
              url: "/orders/details/preview",
              navText: $_("tutorial_orders_detail_preview"),
              component: Orderreport,
            },
            {
              url: "/orders/details/visor",
              navText: $_("tutorial_budget_detail_visor"),
              component: Budgetvisor,
            },
          ],
        },
      ],
    },
    {
      url: "/budgets",
      navText: $_("tutorial_nav_budgets"),
      component: TutoBudgets,
      childrens: [
        {
          url: "/budgets/reference",
          navText: $_("tutorial_budget_reference"),
          component: Budgetid,
        },
        {
          url: "/budgets/filter",
          navText: $_("tutorial_budget_filter"),
          component: Budgetfilter,
        },
        {
          url: "/budgets/settings",
          navText: $_("tutorial_budget_settings"),
          component: Budgetsettings,
        },
        {
          url: "/budgets/details",
          navText: $_("tutorial_budget_details"),
          component: Bdetails,
          childrens: [
            // {
            //   url: "/budgets/details/modify",
            //   navText: $_("tutorial_budget_detail_modify"),
            //   component: Budgetmodify,
            // },
            {
              url: "/budgets/details/order",
              navText: $_("tutorial_budget_detail_order"),
              component: Budgetorder,
            },
            {
              url: "/budgets/details/delete",
              navText: $_("tutorial_budget_detail_delete"),
              component: Budgetdelete,
            },
            {
              url: "/budgets/details/report",
              navText: $_("tutorial_budget_detail_preview"),
              component: Budgetreport,
            },
            {
              url: "/budgets/details/visor",
              navText: $_("tutorial_budget_detail_visor"),
              component: Budgetvisor,
            },
          ],
        },
      ],
    },

    {
      url: "/config",
      navText: $_("tutorial_nav_config"),
      component: Config,
      childrens: [
        {
          url: "/config/vendors",
          navText: $_("tutorial_config_vendors"),
          component: Confvendors,
          childrens: [
            {
              url: "/config/client",
              navText: $_("tutorial_config_vendor_client"),
              component: Clientchange,
            },
            {
              url: "/config/new",
              navText: $_("tutorial_config_vendor_new"),
              component: Vendornew,
            },
            {
              url: "/config/edit",
              navText: $_("tutorial_config_vendor_edit"),
              component: Vendoredit,
            },
            {
              url: "/config/delete",
              navText: $_("tutorial_config_vendor_delete"),
              component: Vendordelete,
            },
          ],
        },
        {
          url: "/config/tarifs",
          navText: $_("tutorial_config_tarif"),
          component: Conftarifs,
        },
      ],
    },
  ];

  const flatten = (arr, key, level = 0) =>
    arr.reduce((acc, r) => {
      acc.push({ ...r, level });
      if (r[key] && r[key].length) {
        acc = acc.concat(flatten(r[key], key, level + 1));
      }
      return acc;
    }, []);

  const pathVisible = (path, query) =>
    path.level === 0 ||
    path.url === query ||
    path.url === query.replace(/\/[^/]+$/, "") ||
    path.url.replace(/\/[^/]+$/, "") === query ||
    path.url.replace(/\/[^/]+$/, "") === query.replace(/\/[^/]+$/, "") ||
    path.url.replace(/\/[^/]+$/, "") ===
      query.replace(/\/[^/]+$/, "").replace(/\/[^/]+$/, "");

  const allArrPaths = flatten(paths, "childrens");

  $: actualPath =
    pathFilters.find((p) =>
      tutoPath ? p.url === tutoPath : p.url === path
    ) || paths[0];

  let pathFilters = [];
  let path
  querystring.subscribe(
    qs => {
      let sp = new URLSearchParams(qs)
      if(sp.has('path'))
        path = sp.get('path')
      else
        path = qs
      setupI18n()
      pathFilters = allArrPaths.filter((p) => pathVisible(p, path))
    }
  );
  // $: pathFilters = allArrPaths.filter(p => pathVisible(p, tutoPath ?? '')) ?? []

  onMount(() => {
    if (allArrPaths.length !== new Set(allArrPaths.map((e) => e.url)).size)
      console.log("Hay urls repetidas");
  });
</script>

<main>
  <div style="height: 0;"></div>
  <nav>
    <h3>{$_("tutorial_nav_title")}</h3>
    <ul class="link-list">
      {#each pathFilters as path}
        <!-- <li on:click={() => tutoPath = path.url} class:active-tuto={actualPath.url === path.url} style="margin-left: calc(1rem * {path.level})">{path.navText}</li> -->
        <li class:active-tuto={actualPath.url === path.url}>
          <a
            href={$location + "?" + path.url}
            use:linkUse
            style="margin-left: calc(1rem * {path.level})">{path.navText}</a
          >
        </li>
      {/each}
    </ul>
  </nav>
  <div>
    <svelte:component this={actualPath.component} />
  </div>
</main>

<svelte:head>
  <link rel="stylesheet" href="/styles/pages/tutorials.css" />
</svelte:head>

<style>
  main {
    display: grid;
    grid-template-columns: 350px 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    overflow-y: auto;
    height: 100%;
  }

  nav {
    overflow-y: auto;
    width: 350px;
    padding-top: 150px;
    padding-left: 15px;
    height: 100%;
    overflow-x: hidden;
    position: fixed;
    box-shadow: rgb(50 50 93 / 10%) 0px 30px 60px -12px, rgb(0 0 0 / 30%) 0px 18px 36px -18px;
  }

  h3 {
    font-size: 18px;
    letter-spacing: 1.7px;
    color: var(--theme-color-4);
    padding-bottom: 15px;
    padding: 5px;
    text-align: center;
    border-bottom: 1px solid var(--gray-color);
    text-align: start;
    width: fit-content;
    margin: 0 auto;
  }

  .link-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-top: 1rem;
    margin: 0;
    align-items: start;
    width: 100%;
    letter-spacing: 0.7px;
    padding-right: 0;
  }

  .link-list li {
    margin-bottom: 3px;
    width: 100%;
    position: relative;
    line-height: 16px;
  }

  .link-list li > a {
    padding: 5px;
    cursor: pointer;
    color: var(--theme-color-4);
    font-weight: 400;
    text-decoration: none;
    padding: 5px;
    letter-spacing: 1.5px;
    width: 100%;
    display: block;
  }

  .link-list li.active-tuto a,
  .link-list li.active-tuto:hover a {
    font-weight: 500;
  }

  .link-list li:hover a {
    color: var(--theme-color-2);
  }

  .active-tuto::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border: 6px solid transparent;
    transform: translateY(-50%);
    top: 50%;
    border-right-color: var(--theme-color-4);
    right: 0;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 1515px) {
    nav {
    width: 250px;
    padding-top: 100px;

    }

    h3 {
      padding-bottom: 5px;
      font-size: 14px;
    }

    .link-list {
      font-size: 14px;
      padding: 5px 0;
    } 
    
  }


  @media (max-width: 1085px) {


    
  }


</style>
